import React, { useState } from 'react'
import { CgMiniPlayer } from 'react-icons/cg';
import { FaHeart, FaRegHeart, FaShare } from 'react-icons/fa';
import { MdComment } from 'react-icons/md';
import { RiFullscreenLine } from 'react-icons/ri';
import UseToggle from '../Hooks/UseToggle';
import { IoClose } from 'react-icons/io5';
import ShairModal from '../Modal/ShairModal';

const VideoCard = ({ src, index, videoRef, onClick }) => {
    const { toggle, setToggle } = UseToggle();
    const [likedVideos, setLikedVideos] = useState({});
    const [isVisible, setIsVisible] = useState(false);
    const [selectedVideo, setSelectedVideo] = useState(null);

    const handleLikeClick = (index) => {
        setLikedVideos((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    }

    const handleClose = () => {
        setIsVisible(false);
        setSelectedVideo(null);
    }
    return (
        <div className="slider-children" data-index={index} onClick={onClick}>
            <div className="position-relative w-100 overflow-hidden"
                style={{
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                }}
            >
                <div id='reelbox' key={index} className="position-relative">
                    <video
                        ref={videoRef}
                        width="100%"
                        autoPlay
                        muted
                        loop
                        style={{ maxWidth: "500px", cursor: "pointer" }}
                        data-index={index}
                    >
                        <source src={src} type="video/mp4" />
                    </video>
                    <div className="overlay">
                        <div className="overlay-icons">
                            {likedVideos[index] ? (
                                <FaHeart
                                    className="icon"
                                    style={{ color: "red" }}
                                    onClick={() => handleLikeClick(index)}
                                />
                            ) : (
                                <FaRegHeart
                                    className="icon"
                                    onClick={() => handleLikeClick(index)}
                                />
                            )}
                            <MdComment className="icon" />
                            <FaShare className="icon" onClick={setToggle} />
                            <RiFullscreenLine
                                className="icon"
                            />
                            <CgMiniPlayer
                                className="icon"
                            />
                        </div>
                        <span className="overlay-description">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                            enim ad minim veniam
                        </span>
                    </div>
                </div>
                {isVisible && (

                    <div className="miniplayer">
                        <div className="miniplayer-header">
                            <span className="title">Mediorana</span>
                            <button className="close-button" onClick={handleClose}><IoClose /></button>
                        </div>
                        <div className="miniplayer-content">
                            <video controls autoPlay>
                                <source src={selectedVideo} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                        <div className="miniplayer-footer">
                            <span className="channel">Galax OTT</span>
                        </div>

                    </div>
                )}
            </div>
            <ShairModal
                Show={!toggle}
                Hide={setToggle}
                Size={"lg"}
                backdrop="static"
                keyboard="false"
            />
        </div>
    );
};

export default VideoCard;

